export default __webpack_public_path__ + "974c190fda53709a62e8b6cf5d00d218.png";